import { render, staticRenderFns } from "./ActivationBriefTasksView.vue?vue&type=template&id=12810a35&scoped=true&"
import script from "./ActivationBriefTasksView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTasksView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefTasksView.vue?vue&type=style&index=0&id=12810a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12810a35",
  null
  
)

export default component.exports